import { render, staticRenderFns } from "./scroll-wrapper.vue?vue&type=template&id=b3e1c4b0&"
import script from "./scroll-wrapper.vue?vue&type=script&lang=ts&"
export * from "./scroll-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./scroll-wrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports